if(typeof projects_filter != 'undefined'){
	let WinklerProjects= {
		init: function(){
			//settano iz smarty tpla
			this.projects_filter=projects_filter;
			this.search=projects_search;
			this.pg=vudu_pager_current_page;

			this.load_more_tgt= document.querySelector('div.xLoadMoreTarget');
			this.load_more_btn= document.querySelector('a.xLoadMore');

			this.bindEvents();
		},
		bindEvents: function(){
			if(this.load_more_btn){
				let load_more_fnbound=(function(e){
					e.preventDefault();
					this.pg += 1;
					this.fetch_uri = processedUri;					
					
					// let btn= load_more;
					// if(btn.href){
					// 	this.fetch_uri= btn.href
					// }

					this.xfetch();

				}).bind(this);
				this.load_more_btn.addEventListener("click", load_more_fnbound);
			}
			let search_input= document.querySelector('input[name='+this.search.query_param+']');
			if(search_input){
				let search_fn= function(e){
					console.log(this);
					this.search.query_value= search_input.value;
					this.pg = 1;
					this.fetch_uri = processedUri;
					this.xfetch(false);
				};
				let search_fnbound= search_fn.bind(this);
				search_input.addEventListener("keyup", (function(e) {
					if (event.key === "Enter") search_fn.apply(this,e);
				}).bind(this));
				
				let confirm_button = search_input.parentElement.querySelector('button');
				if(confirm_button){
					confirm_button.addEventListener("click", search_fnbound)
				}
			}
			let filter_sels= document.querySelectorAll('div.filters-block__item>select');
			if(filter_sels.length > 0){
				let filter_fnbound= (function(e){
					//malo hacky, search ima prednost, resetamo kad select filter
					let el= e.target;
					if(typeof this.projects_filter[el.id] != 'undefined'){
						this.projects_filter[el.id].query_value= el.value;
					}
					this.search.query_value= '';
					this.pg = 1;
					this.fetch_uri = processedUri;
					this.xfetch(false);
				}).bind(this);
				for(let sel of filter_sels){
					sel.addEventListener('change',filter_fnbound);
				}
			}
		},
		loading:false,
		xfetch:function(append=true){
			if(!this.loading){
				this.loading=true;
				let post_body=new FormData();
				post_body.set('xjs',true);
	
				let uri= this.fetch_uri;
				let params= this.projects_filter_params();
				let query_string=params.toString();
				if (params.size>0){
					uri += '?' + query_string;
				}

				let load_more_clear= async function(res){
					if(res.ok){
						this.load_more_tgt.innerHTML='';
					}
				};
				let res_handle= async function(res){
					this.loading=false;
					if(!res.ok) return;
					const data= await res.json();
					
					if(data.success){
						if(this.load_more_tgt){
							this.load_more_tgt.innerHTML+=data.out_html;
						}
						this.load_more_btn.hidden= !(data.can_load_more);
						
						history.pushState(null, '', uri);
					}
				};
				let f= fetch(uri,{ method:'post',body:post_body });
				if(!append){
					f.then(load_more_clear.bind(this));
				}
				f.then(res_handle.bind(this));
			}
		},
		
		projects_filter_params: function(){
			let params = new URLSearchParams();
			if(this.search.query_value != ''){
				params.set(this.search.query_param, this.search.query_value);
			}else{
				for(let fKey of Object.keys(projects_filter)){
					let filter=projects_filter[fKey];
					if(filter.query_value != 'all'){ //todo all is hc, define dead value
						params.set(filter.query_param, filter.query_value);
					} 
				}
			}
			if(this.pg > 1){
				params.set('pg', this.pg);
			}
			return params;
		}
	}
	
	WinklerProjects.init();
}